import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import GetIcon from '../../../../utils/Icon';
import VersionHistory from '../../../../utils/VersionHistory';
import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab1 = ({vendor,po,activityboll}) => {
  console.log("po   polistpolistpolistpolistpolistpolistpolist",po.polist);
  const [showActivity, setShowActivity] = useState(true);
  return (
    <div
     className="row sidebarbox m-0 d-flex flex-column" style={{ padding: "8px", borderRadius: "5px", height: '72vh', overflowY: 'scroll',flexWrap:'nowrap' }}
    >
      <div className="col-12 mb-2">
        <Input id="termsandconditions" label="GRN No." readOnly value={po.current_op} style={{ height: '30px' }} />
      </div>
      <div className="col-12 mb-3">
         <SelectSearch
            list={po.polist}
            label="Select PO No."
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={po.selectedpo}
            onChange={(val) => po.setselectedpo(val)}
          /> 
        

      </div>

      <div className="col-12 mb-2">

        <Input id="termsandconditions" label="Supplier" readOnly value={vendor.vendor} style={{ height: '30px' }} />

      </div>
      <div className="col-12 mb-2">
  
        <Input id="termsandconditions" label="Post Date" readOnly value={po.postDate} style={{ height: '30px' }} />

        
      </div>
      <div className="col-12 mb-2">
 

        <Input id="termsandconditions" label="Post Time" readOnly value={po.postTime?.split('.')[0]} style={{ height: '30px' }} />

      </div>

       <CollapsibleSection title="Accounting Dimensions">
          <div className="col-lg-12 mt-3 mb-3" >
        <Input id="termsandconditions" label="Cost Center" value={po.fulldata.message?.cost_center} readOnly style={{ height: '30px' }} />

          </div>
          <div className="col-lg-12 mt-3 mb-3" >
            <div className={`mb-3`}>
            

        <Input id="termsandconditions" label="Project" value={po.fulldata.message?.project} readOnly style={{ height: '30px' }} />

            </div>
          </div>
        </CollapsibleSection>
  
        <CollapsibleSection title="Currency and Price List">
          <div className="col-lg-12 mt-3 mb-3" >
            <div className={`mb-3`}>
        <Input id="termsandconditions" label="Currency" readOnly value={po.fulldata.message?.currency} style={{ height: '30px' }} />

           </div>
          </div>
  
          <div className="col-lg-12 mt-3 mb-3" >
            <div className={`mb-3`}>
        <Input id="termsandconditions" label="Price List" value={po.fulldata.message?.buying_price_list} readOnly style={{ height: '30px' }} />

          </div>
          </div>
        </CollapsibleSection>
  
        <CollapsibleSection title="Taxes and Charges">
            <div className="col-lg-12 mt-3 mb-3" >
            <div className={`mb-3`}>
        <Input id="termsandconditions" label="Taxes and Charges" value={po.fulldata.message?.taxes_and_charges} readOnly style={{ height: '30px' }} />

          </div>
          </div>
        </CollapsibleSection>
  
        {/* <CollapsibleSection title="Payment Terms">
          <div className="col-lg-12 mt-3 mb-3" >
            <div className={`mb-3`}>
        <Input id="termsandconditions" label="Payment Terms Template" value={po.fulldata.message?.payment_terms_template} readOnly style={{ height: '30px' }} />

          </div>
          </div>
          
        </CollapsibleSection> */}
       
        <CollapsibleSection title="Terms & Conditions">
     
          <div className="col-lg-12 mt-1 mb-3" >
             <div className={`mb-3`}>
        <Input id="termsandconditions" label="Terms and Conditions" value={po.fulldata.message?.tc_name} readOnly style={{ height: '30px' }} />

          </div>
          </div>
  
        </CollapsibleSection>




      <div className="col-12">
          <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
            <p className="firstcolor m-0" >
              Activity
            </p>
            <GetIcon
              iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
              size={22}
            />
          </div>
          {showActivity && (
            <VersionHistory doctype="Purchase Receipt" docname={po.current_op} activityboll={activityboll} />

          )}
        </div>
     </div>
  )
}

export default Tab1